/* eslint-disable no-param-reassign */
import { sortTypeEnum } from '@/constants/global';
import { EHubListMutations, } from './types';
const mutations = {
    [EHubListMutations.SET_FILTER_OPTION]({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    [EHubListMutations.SET_SORT_OPTION]: (state, payload) => {
        state.sortOption = payload.length > 0 ? payload : [
            {
                // 정렬 대상
                field: 'name',
                // 정렬 기준
                value: sortTypeEnum.ASC,
            },
        ];
    },
    [EHubListMutations.GET_HUB_LIST](state, { list, paginationData }) {
        state.hubList = list;
        state.paginationData = paginationData;
    },
};
export default mutations;
